import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  ModalFooter,
  Button,
  Col,
} from "reactstrap";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AddSchoolToSupervisor } from "../../actions/teacherMutations";
import { toast } from "react-toastify";
import { FormattedMessage, useIntl } from "react-intl";

export default function PromptAddSupervisorToSchool({
  supervisor,
  toggle,
  isOpen,
  dismissModal,
  schoolId,
  setSubmitting,
}) {
  const intl = useIntl();
  const postSupervisorToSchool = useMutation({ mutationFn: AddSchoolToSupervisor });
  const queryClient = useQueryClient();

  const handlePostSupervisorToSchool = () => {
    let supervisorSchool = {
      supervisorId: supervisor.id,
      schoolId: schoolId,
    };
    postSupervisorToSchool.mutate(supervisorSchool, {
      onSuccess: (data) => {
        if (data && data.status > 199 && data.status < 300) {
          toast.success(intl.formatMessage({ id: "SupervisorAdded" }));
          queryClient.invalidateQueries({ queryKey: ["FetchSupervisors", schoolId] });
          dismissModal();
        } else {
          if (data.trim() === "Supervisor already has this school") {
            toast.warn(intl.formatMessage({ id: "SupervisorAlreadyHasSchool" }));
          } else {
            toast.warn(data);
          }
          setSubmitting(false);
        }
      },
      throwOnError: true,
      onError: (data) => {
        toast.warn(data.response.data);
        setSubmitting(false);
      },
    });
    toggle();
  };

  if (supervisor) {
    return (
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader>
          <FormattedMessage id="UserAlreadyExists" />
        </ModalHeader>
        <ModalBody>
          <FormattedMessage
            values={{
              supervisorEmail: supervisor.email,
            }}
            id="SupervisorWithNameAlreadyExistsInSystem"
          />
          :
          <Row>
            <Col>
              <FormattedMessage id="Name" />: {supervisor.name}
            </Col>
          </Row>
          <Row>
            <Col>
              <FormattedMessage id="Phone" />: {supervisor.phone}
            </Col>
          </Row>
          <Row>
            <Col>
              <FormattedMessage id="DoYouWantToAddThisSupervisorToSchool" />?
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter style={{ display: "block" }}>
          <Button
            onClick={() => handlePostSupervisorToSchool()}
            className={"float-start btn-success"}
          >
            <FormattedMessage id="Yes" />
          </Button>
          <Button
            onClick={toggle}
            className="float-end"
            color="secondary"
            outline
          >
            <FormattedMessage id="Cancel" />
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
  return null;
}
